/* Silvery Silver: product card quick view and ADD button (owner request, 22 Oct 2026).
   Loaded on every page by sections/ss-header.liquid. Works with the cards in snippets/ss-card-product.liquid:
   - [data-ss-qv] (eye button, and ADD on products with sizes/options): opens a pop-up with the product's images,
     price, size, quantity, Add to cart and "View product details". The content comes from Shopify's Section Rendering
     API (sections/ss-quickview.liquid), so prices, stock and images are always Shopify's own.
   - form[data-ss-card-add] (ADD on single-variant products): adds one piece to the cart.
   Adding uses Shopify's /cart/add.js and then the theme's own cart notification (cart-notification.js), the same
   one the product page uses. Prices, discounts, checkout, COD and payment apps are not touched.
   If anything fails to load, the links simply open the product page. */
(function () {
  'use strict';

  if (window.ssQuickView) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var dialog = null;
  var body = null;
  var trigger = null;
  var cache = {};
  var supportsDialog = typeof HTMLDialogElement === 'function';

  /* ---------- Cart ---------- */
  function cartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addToCart(variantId, quantity, focusEl) {
    var cart = cartEl();
    var payload = { id: variantId, quantity: quantity };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function' && focusEl) cart.setActiveElement(focusEl);
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, data: j }; });
      })
      .then(function (res) {
        var d = res.data || {};
        if (!res.ok || d.status) {
          throw new Error(d.description || d.message || 'Could not add to cart. Please try again.');
        }
        try {
          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-quick-add', productVariantId: variantId, cartData: d });
          }
        } catch (e) { /* never block the cart */ }
        return { cart: cart, data: d };
      });
  }

  function showCart(result) {
    if (result.cart && typeof result.cart.renderContents === 'function' && result.data.sections) {
      try {
        result.cart.renderContents(result.data);
        return;
      } catch (e) { /* fall through to the cart page */ }
    }
    window.location.href = root + 'cart';
  }

  /* ---------- Card ADD (single variant) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-ss-card-add]') : null;
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-busy');
    addToCart(Number(form.querySelector('[name="id"]').value), 1, btn)
      .then(function (res) {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.textContent = 'Added';
        showCart(res);
        window.setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 2000);
      })
      .catch(function (err) {
        btn.classList.remove('is-busy');
        btn.textContent = label;
        window.alert(err.message);
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Quick view ---------- */
  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'ss ss-qv';
    dialog.setAttribute('aria-labelledby', 'SsQvTitle');
    dialog.innerHTML =
      '<button type="button" class="ss-qv__close" data-ss-qv-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button><div class="ss-qv__body" data-ss-qv-body></div>';
    document.body.appendChild(dialog);
    body = dialog.querySelector('[data-ss-qv-body]');
    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-ss-qv-close]')) { close(); return; }
      if (e.target === dialog) {
        var r = dialog.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside || e.clientX === 0) close();
      }
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('ss-qv-open');
      body.innerHTML = '';
      if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    });
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  function sectionUrl(href) {
    var u = new URL(href, window.location.origin);
    u.searchParams.set('section_id', 'ss-quickview');
    u.hash = '';
    return u.toString();
  }

  function load(href) {
    var key = sectionUrl(href);
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch(key, { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('quick view ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-ss-qv-content]');
        if (!content) throw new Error('quick view: no content');
        cache[key] = content.outerHTML;
        return cache[key];
      });
  }

  function open(href, from) {
    if (!supportsDialog || !window.fetch) { window.location.href = href; return; }
    if (!dialog) build();
    trigger = from || null;
    body.innerHTML = '<div class="ss-qv__loading" role="status"><span class="ss-qv__spinner" aria-hidden="true"></span><span class="visually-hidden">Loading</span></div>';
    document.documentElement.classList.add('ss-qv-open');
    if (!dialog.open) dialog.showModal();
    load(href)
      .then(function (html) {
        if (!dialog.open) return;
        body.innerHTML = html;
        init(body.querySelector('[data-ss-qv-content]'));
      })
      .catch(function () {
        close();
        window.location.href = href;
      });
  }

  function init(el) {
    var variants = [];
    try { variants = JSON.parse(el.querySelector('[data-ss-qv-variants]').textContent); } catch (e) { variants = []; }
    var track = el.querySelector('[data-ss-qv-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dots = Array.prototype.slice.call(el.querySelectorAll('.ss-qv__dot'));
    var priceEl = el.querySelector('[data-ss-qv-price]');
    var msg = el.querySelector('[data-ss-qv-msg]');
    var addBtn = el.querySelector('[data-ss-qv-add]');
    var addLabel = el.querySelector('[data-ss-qv-add-label]');
    var addText = addLabel ? addLabel.textContent : 'Add to cart';
    var qty = el.querySelector('[data-ss-qv-qty]');
    var groups = Array.prototype.slice.call(el.querySelectorAll('[data-ss-qv-opt]'));
    var fixed = Array.prototype.slice.call(el.querySelectorAll('[data-ss-qv-fixed]'));
    var optionCount = groups.length + fixed.length;
    var choose = el.getAttribute('data-choose') || 'options';

    /* Gallery */
    function index() {
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function go(i) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    if (track) {
      track.addEventListener('scroll', function () {
        var i = index();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
      });
    }
    var prev = el.querySelector('[data-ss-qv-prev]');
    var next = el.querySelector('[data-ss-qv-next]');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });

    /* Variants */
    function selected() {
      if (!variants.length) return null;
      if (optionCount === 0) return variants[0];
      var values = [];
      for (var i = 0; i < optionCount; i += 1) values[i] = null;
      fixed.forEach(function (f) { values[Number(f.getAttribute('data-ss-qv-fixed'))] = f.value; });
      groups.forEach(function (g) {
        var c = g.querySelector('input:checked');
        values[Number(g.getAttribute('data-ss-qv-opt'))] = c ? c.value : null;
      });
      if (values.indexOf(null) !== -1) return null;
      for (var v = 0; v < variants.length; v += 1) {
        var ok = true;
        for (var k = 0; k < values.length; k += 1) if (String(variants[v].options[k]) !== values[k]) { ok = false; break; }
        if (ok) return variants[v];
      }
      return null;
    }
    function allChosen() {
      return groups.every(function (g) { return !!g.querySelector('input:checked'); });
    }
    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }
    /* Only one option with choices (most products: Size): mark values that are sold out */
    if (groups.length === 1) {
      var gi = Number(groups[0].getAttribute('data-ss-qv-opt'));
      groups[0].querySelectorAll('input').forEach(function (input) {
        var any = variants.some(function (v) { return String(v.options[gi]) === input.value && v.available; });
        if (!any) input.closest('.ss-qv__pill').classList.add('is-soldout');
      });
    }
    function hideMsg() { if (msg) { msg.hidden = true; msg.textContent = ''; } }
    function showMsg(t) { if (msg) { msg.textContent = t; msg.hidden = false; } }

    function update() {
      hideMsg();
      var v = selected();
      if (v && priceEl) {
        priceEl.innerHTML = '<span class="ss-qv__now">' + esc(v.price) + '</span>' + (v.was ? '<s class="ss-qv__was">' + esc(v.was) + '</s>' : '');
      }
      if (addBtn) {
        var sold = !!(v && !v.available) || (!v && allChosen() && optionCount > 0);
        addBtn.disabled = sold;
        if (addLabel) addLabel.textContent = sold ? 'Sold out' : addText;
      }
      if (v && qty) {
        if (v.max != null && v.max > 0) qty.max = v.max; else qty.removeAttribute('max');
        clampQty();
      }
      if (v && v.media && track) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i].getAttribute('data-media-id') === String(v.media)) { go(i); break; }
        }
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', update); });

    /* Quantity */
    function clampQty() {
      if (!qty) return 1;
      var n = parseInt(qty.value, 10);
      if (!n || n < 1) n = 1;
      var max = qty.max ? parseInt(qty.max, 10) : 0;
      if (max && n > max) n = max;
      qty.value = n;
      return n;
    }
    var minus = el.querySelector('[data-ss-qv-minus]');
    var plus = el.querySelector('[data-ss-qv-plus]');
    if (minus) minus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) - 1; clampQty(); });
    if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; clampQty(); });
    if (qty) qty.addEventListener('change', clampQty);

    /* Add to cart */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var v = selected();
        if (!v) {
          showMsg('Please choose a ' + choose + '.');
          var first = groups.filter(function (g) { return !g.querySelector('input:checked'); })[0];
          if (first) { var f = first.querySelector('input'); if (f) f.focus(); }
          return;
        }
        if (!v.available || addBtn.getAttribute('aria-busy') === 'true') return;
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.classList.add('is-busy');
        hideMsg();
        addToCart(v.id, clampQty(), trigger)
          .then(function (res) {
            close();
            showCart(res);
          })
          .catch(function (err) {
            showMsg(err.message);
          })
          .then(function () {
            addBtn.removeAttribute('aria-busy');
            addBtn.classList.remove('is-busy');
          });
      });
    }

    update();
  }

  /* ---------- Open from cards ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-ss-qv]') : null;
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return; /* new tab: plain product link */
    e.preventDefault();
    open(a.getAttribute('data-ss-qv') || a.getAttribute('href'), a);
  });
  document.addEventListener('keydown', function (e) {
    /* role="button" links: Space opens too */
    if (e.key !== ' ') return;
    var a = e.target && e.target.closest ? e.target.closest('a[data-ss-qv]') : null;
    if (!a) return;
    e.preventDefault();
    open(a.getAttribute('data-ss-qv') || a.getAttribute('href'), a);
  });

  window.ssQuickView = { open: open, close: close };
})();
